import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { KIT_DETAIL } from "../apiRoutes";

interface KitResponse {
  data: any;
}

const fetchKitDetail = async (id: string) => {
  const response = await axiosAuth.get<KitResponse>(
    `${KIT_DETAIL}${id}`
  );
  return response.data;
};

const useGetKitDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["KitDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["KitDetail", string | undefined]>({
    queryKey: ["kitDetail", id],
    queryFn: () => fetchKitDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetKitDetailQuery;


